import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

export const updateInstallmentCreditCardOperation = async (
  user: UserSummaryType,
  installmentPlanId: number,
  creditCardTokenId: number,
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const res = await appApi.updateInstallmentPlanCreditCard(
      user.id,
      installmentPlanId,
      creditCardTokenId,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    // Refresh user details to get updated installments
    const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    toast.success('כרטיס האשראי עודכן בהצלחה');
    setLoading(false);
    onSuccess?.();
    return true;
  } catch (e) {
    console.error('Error updating installment credit card:', e);
    toast.error('שגיאה בעדכון כרטיס האשראי');
    setLoading(false);
    return false;
  }
};
